<template>
	<div :style="$attrs.style" class="line-graph-container">
		<LineChart
			v-if="
				chartdata && chartdata.datasets && chartdata.datasets.length > 0
			"
			:chartData="chartdata"
			:chartOptions="mergedOptions"
			:style="$attrs.style"
			ref="lineChart"
		/>
		<div v-else class="no-data">No chart data available</div>
	</div>
</template>

<script>
	import {
		Chart as ChartJS,
		CategoryScale,
		LinearScale,
		PointElement,
		LineElement,
		Title,
		Tooltip,
		Legend,
	} from "chart.js";
	import { Line } from "vue-chartjs";
	import { ref, computed, onMounted, nextTick } from "vue";

	ChartJS.register(
		CategoryScale,
		LinearScale,
		PointElement,
		LineElement,
		Title,
		Tooltip,
		Legend
	);

	export default {
		name: "LineGraph",
		inheritAttrs: false,
		components: {
			LineChart: Line,
		},
		props: {
			chartdata: {
				type: Object,
				default: () => ({ datasets: [], labels: [] }),
			},
			options: {
				type: Object,
				default: () => ({}),
			},
		},
		setup(props, { emit }) {
			const lineChart = ref(null);
			const loaded = ref(false);

			const mergedOptions = computed(() => {
				const defaultOptions = {
					responsive: true,
					maintainAspectRatio: false,
					resizeDelay: 0,
					plugins: {
						legend: {
							display: true,
						},
					},
					onClick: (evt, elements) => {
						if (
							elements.length > 0 &&
							props.chartdata &&
							props.chartdata.labels &&
							props.chartdata.datasets
						) {
							// Get the index of the clicked element
							const clickedElementIndex = elements[0].index;
							// Get the actual label
							const label =
								props.chartdata.labels[clickedElementIndex];
							// Get the value
							const value =
								props.chartdata.datasets[0].data[
									clickedElementIndex
								];

							// Emit the click event with the data
							emit("label-click", {
								label,
								value,
								index: clickedElementIndex,
							});
						}
					},
					// Make the cursor a pointer when hovering over points
					onHover: (evt, elements) => {
						if (evt.native && evt.native.target) {
							evt.native.target.style.cursor =
								elements.length > 0 ? "pointer" : "default";
						} else if (evt.chart && evt.chart.canvas) {
							evt.chart.canvas.style.cursor =
								elements.length > 0 ? "pointer" : "default";
						}
					},
				};

				return { ...defaultOptions, ...props.options };
			});

			onMounted(() => {
				loaded.value = true;
				// Force chart resize after mount
				nextTick(() => {
					if (lineChart.value && lineChart.value.chart) {
						lineChart.value.chart.resize();
					}
				});
			});

			return {
				lineChart,
				loaded,
				mergedOptions,
			};
		},
	};
</script>

<style scoped>
	.line-graph-container {
		width: 100%;
		position: relative;
		> div {
			height: 100%;
			width: 100%;
		}
	}

	.line-graph-container canvas {
		max-height: none !important;
		height: 100% !important;
	}

	.no-data {
		display: flex;
		align-items: center;
		justify-content: center;
		min-height: 200px;
		color: #666;
	}
</style>
